export default __webpack_public_path__ + "static/media/fish&chips-italic.f05b7d24.otf";